import { useState, useEffect } from 'react';
import { checkConsent } from './use-consent';
import { STORAGE_KEYS } from '@/lib/storage-keys';

export function useFavorites() {
  const [favorites, setFavorites] = useState<string[]>(() => {
    if (!checkConsent()) return [];
    try {
      const stored = localStorage.getItem(STORAGE_KEYS.FAVORITES.key);
      return stored ? JSON.parse(stored) : [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    if (!checkConsent()) return;
    try {
      localStorage.setItem(STORAGE_KEYS.FAVORITES.key, JSON.stringify(favorites));
    } catch (error) {
      console.error('Failed to save favorites:', error);
    }
  }, [favorites]);

  const addFavorite = (toolId: string) => {
    if (!checkConsent()) return;
    setFavorites((prev) => [...prev, toolId]);
  };

  const removeFavorite = (toolId: string) => {
    if (!checkConsent()) return;
    setFavorites((prev) => prev.filter((id) => id !== toolId));
  };

  const toggleFavorite = (toolId: string) => {
    if (!checkConsent()) return;
    setFavorites((prev) =>
      prev.includes(toolId) ? prev.filter((id) => id !== toolId) : [...prev, toolId]
    );
  };

  const isFavorite = (toolId: string) => {
    return favorites.includes(toolId);
  };

  return {
    favorites,
    addFavorite,
    removeFavorite,
    toggleFavorite,
    isFavorite,
  };
}
